import { normalizeImageUrl } from './imageUtils';
import {
    stripHtmlToPlainText,
    extractFirstImageUrlFromHtml,
    splitParagraphs,
} from './aboutTextUtils';

export const ABOUT_PLACEHOLDER_IMAGES = {
    hero: '/assets/introduce.png',
    mission: '/assets/images/bao-duong-gam-xe-o-to-4.jpg',
    vision: '/assets/images/hethong.jpg',
    branch: '/assets/images/hethong.jpg',
    timeline: [
        '/assets/images/khai-truong-ha-thanh-garage-chi-nhanh-thach-ban-long-bien-1-1.jpg',
        '/assets/images/ceo-nguyen-ngoc-ha-du-ky-niem-20-nam-thanh-lap-truong-2-1.jpg',
        '/assets/images/ha-thanh-garage-ky-ket-hop-tac-voi-expel-4.jpg',
        '/assets/images/dich-vu-son-o-to.jpg',
        '/assets/images/79bd10e21f7b0564c557bde29cc8c1e6.jpg',
    ],
    featureIcons: [
        '/assets/images/icon-dv-1.png',
        '/assets/images/icon-dv-2.png',
        '/assets/images/icon-dv-3.png',
    ],
    sectionIcons: {
        vision: '/assets/images/icon-dv-1.png',
        values: '/assets/images/icon-dv-2.png',
    },
};

export const INTRO_FEATURES_FALLBACK = [
    { iconUrl: '/assets/images/icon-dv-1.png', title: 'CHUYÊN NGHIỆP', description: 'Đội ngũ kỹ thuật viên chuyên môn cao' },
    { iconUrl: '/assets/images/icon-dv-2.png', title: 'TRANG THIẾT BỊ HIỆN ĐẠI', description: 'Hệ thống máy móc, công nghệ tân tiến' },
    { iconUrl: '/assets/images/icon-dv-3.png', title: 'MINH BẠCH - UY TÍN', description: 'Báo giá rõ ràng, không phát sinh chi phí' },
    { iconUrl: '/assets/images/icon-dv-1.png', title: 'BẢO HÀNH CHU ĐÁO', description: 'Chế độ bảo hành rõ ràng, tận tâm' },
];

const DEMO_FEATURES = INTRO_FEATURES_FALLBACK;

const DEMO_TIMELINE = [
    { imageUrl: ABOUT_PLACEHOLDER_IMAGES.timeline[0], year: '2015', description: 'Thành lập và đi vào hoạt động' },
    { imageUrl: ABOUT_PLACEHOLDER_IMAGES.timeline[1], year: '2016 - 2018', description: 'Mở rộng quy mô và phát triển dịch vụ' },
    { imageUrl: ABOUT_PLACEHOLDER_IMAGES.timeline[2], year: '2019 - 2021', description: 'Nâng cấp trang thiết bị hiện đại' },
    { imageUrl: ABOUT_PLACEHOLDER_IMAGES.timeline[3], year: '2022 - 2023', description: 'Phát triển hệ thống chi nhánh' },
    { imageUrl: ABOUT_PLACEHOLDER_IMAGES.timeline[4], year: '2024 - Nay', description: 'Khẳng định vị thế trên thị trường' },
];

const DEMO_VALUES = [
    { iconUrl: '/assets/images/icon-dv-1.png', title: 'UY TÍN', description: 'Cam kết chất lượng' },
    { iconUrl: '/assets/images/icon-dv-2.png', title: 'CHUYÊN NGHIỆP', description: 'Đội ngũ giàu kinh nghiệm' },
    { iconUrl: '/assets/images/icon-dv-3.png', title: 'TẬN TÂM', description: 'Phục vụ tận tình' },
    { iconUrl: '/assets/images/icon-dv-2.png', title: 'MINH BẠCH', description: 'Giá cả rõ ràng' },
    { iconUrl: '/assets/images/icon-dv-1.png', title: 'BỀN VỮNG', description: 'Phát triển lâu dài' },
];

const DEFAULT_BRANCHES = [
    {
        _id: 'demo-branch-1',
        name: 'CƠ SỞ 1 - BA ĐÌNH',
        phone: '0966 183 815',
        operatingHours: '7:30 - 18:00 (T2 - CN)',
        address: { street: 'Số 48 - 50 đường Bưởi, Ngọc Khánh', districtName: 'Ba Đình', provinceName: 'Hà Nội' },
        imageUrl: '/assets/images/khai-truong-ha-thanh-garage-chi-nhanh-thach-ban-long-bien-1-1.jpg',
        status: 'ACTIVE',
        order: 0,
    },
    {
        _id: 'demo-branch-2',
        name: 'CƠ SỞ 2 - LONG BIÊN',
        phone: '0966 183 815',
        operatingHours: '7:30 - 18:00 (T2 - CN)',
        address: { street: 'Số 679 - 681 Ngọc Lâm', districtName: 'Long Biên', provinceName: 'Hà Nội' },
        imageUrl: '/assets/images/hethong.jpg',
        status: 'ACTIVE',
        order: 1,
    },
];

const hasText = (val) => typeof val === 'string' && val.trim().length > 0;

const pickImage = (url, fallback) => (hasText(url) && url !== 'string' ? url : fallback);

const iconAt = (i) => ABOUT_PLACEHOLDER_IMAGES.featureIcons[i % ABOUT_PLACEHOLDER_IMAGES.featureIcons.length];

const timelineImageAt = (i) => ABOUT_PLACEHOLDER_IMAGES.timeline[i % ABOUT_PLACEHOLDER_IMAGES.timeline.length];

const isFilled = (item, fields) => item && fields.some((f) => hasText(item[f]));

const plainField = (val) => stripHtmlToPlainText(val);

const resolveSectionImage = (dedicatedUrl, legacyHtml, fallback) => {
    if (hasText(dedicatedUrl) && dedicatedUrl !== 'string' && !dedicatedUrl.includes('<')) {
        return dedicatedUrl;
    }
    const fromHtml = extractFirstImageUrlFromHtml(legacyHtml);
    if (fromHtml) return fromHtml;
    return fallback;
};

const normalizeIconTextList = (items, demoList, imageField = 'iconUrl') => {
    const source = Array.isArray(items)
        ? items.filter((item) => isFilled(item, [imageField, 'title', 'description']))
        : [];

    if (source.length === 0) return demoList;

    return source.map((item, i) => ({
        [imageField]: pickImage(item[imageField], iconAt(i)),
        title: plainField(item.title),
        description: plainField(item.description),
    }));
};

const normalizeTimelineList = (items, demoList) => {
    const source = Array.isArray(items)
        ? items.filter((item) => isFilled(item, ['imageUrl', 'year', 'description']))
        : [];

    if (source.length === 0) return demoList;

    return source.map((item, i) => ({
        imageUrl: pickImage(item.imageUrl, timelineImageAt(i)),
        year: plainField(item.year),
        description: plainField(item.description),
    }));
};

export const mergeAboutDisplayData = (data) => {
    const d = data || {};

    let paragraphs = [];
    if (Array.isArray(d.introParagraphs) && d.introParagraphs.some(hasText)) {
        paragraphs = d.introParagraphs.map(plainField).filter(Boolean);
    } else if (hasText(d.description)) {
        paragraphs = splitParagraphs(d.description);
        if (paragraphs.length <= 1) paragraphs = [plainField(d.description)].filter(Boolean);
    }

    if (paragraphs.length === 0) {
        paragraphs = [
            'Trung Anh Garage là đơn vị chuyên sâu trong lĩnh vực sửa chữa, bảo dưỡng và đại tu hệ thống khung gầm – động cơ ô tô, được xây dựng với định hướng rõ ràng: Chẩn đoán đúng – Sửa chữa chính xác – Tối ưu chi phí cho khách hàng.',
            'Với đội ngũ kỹ thuật viên giàu kinh nghiệm cùng trang thiết bị hiện đại, chúng tôi cam kết mang đến dịch vụ chất lượng cao, minh bạch và tận tâm.',
            'Sự hài lòng và an toàn của khách hàng luôn là ưu tiên hàng đầu trong mọi hoạt động của Trung Anh Garage.',
        ];
    }

    const missionLegacy = d.mission?.content || '';
    const visionLegacy = d.vision?.content || '';

    let missionContent = plainField(d.missionContent) || plainField(missionLegacy);
    let visionContent = plainField(d.visionContent) || plainField(visionLegacy);

    if (!missionContent) {
        missionContent = 'Mang đến dịch vụ sửa chữa, bảo dưỡng xe chuyên nghiệp, minh bạch và tận tâm cho mọi khách hàng.';
    }
    if (!visionContent) {
        visionContent = 'Trở thành hệ thống garage hàng đầu, được khách hàng tin tưởng lựa chọn.';
    }

    const missionImage = resolveSectionImage(
        d.missionImage,
        missionLegacy,
        ABOUT_PLACEHOLDER_IMAGES.mission
    );
    const visionImage = resolveSectionImage(
        d.visionImage,
        visionLegacy,
        ABOUT_PLACEHOLDER_IMAGES.vision
    );

    return {
        ...d,
        introSectionTitle: plainField(d.introSectionTitle) || plainField(d.title) || 'VỀ CHÚNG TÔI',
        introBrandTitle: plainField(d.introBrandTitle) || 'TRUNG ANH GARAGE',
        introParagraphs: paragraphs,
        introHeroImage: resolveSectionImage(
            d.introHeroImage || (Array.isArray(d.imageUrls) ? d.imageUrls[0] : ''),
            d.description,
            ABOUT_PLACEHOLDER_IMAGES.hero
        ),
        introFeatures: normalizeIconTextList(d.introFeatures, DEMO_FEATURES),
        historyTitle: plainField(d.historyTitle) || plainField(d.history?.title) || 'LỊCH SỬ HÌNH THÀNH VÀ PHÁT TRIỂN',
        historyItems: normalizeTimelineList(d.historyItems, DEMO_TIMELINE),
        missionTitle: plainField(d.missionTitle) || plainField(d.mission?.title) || 'SỨ MỆNH',
        missionContent,
        missionImage,
        visionValuesSectionTitle: plainField(d.visionValuesSectionTitle) || 'TẦM NHÌN & GIÁ TRỊ',
        visionTitle: plainField(d.visionTitle) || plainField(d.vision?.title) || 'TẦM NHÌN',
        visionContent,
        visionIconUrl: pickImage(d.visionIconUrl, ABOUT_PLACEHOLDER_IMAGES.sectionIcons.vision),
        visionImage,
        valuesTitle: plainField(d.valuesTitle) || plainField(d.values?.title) || 'GIÁ TRỊ CỐT LÕI',
        valuesIconUrl: pickImage(d.valuesIconUrl, ABOUT_PLACEHOLDER_IMAGES.sectionIcons.values),
        valuesItems: normalizeIconTextList(d.valuesItems, DEMO_VALUES),
        branchesSectionTitle: plainField(d.branchesSectionTitle) || 'HỆ THỐNG CHI NHÁNH',
    };
};

export const mergeBranchesDisplay = (branches) => {
    const branchFallbacks = [
        '/assets/images/khai-truong-ha-thanh-garage-chi-nhanh-thach-ban-long-bien-1-1.jpg',
        '/assets/images/hethong.jpg',
    ];

    const active = Array.isArray(branches)
        ? branches
            .filter((b) => b && b.status !== 'INACTIVE' && b.status !== 'inactive')
            .sort((a, b) => (a.order || 0) - (b.order || 0))
        : [];

    if (active.length > 0) {
        return active.map((b, i) => ({
            ...b,
            imageUrl: pickImage(b.imageUrl, branchFallbacks[i % branchFallbacks.length]),
        }));
    }

    return DEFAULT_BRANCHES.map((b, i) => ({
        ...b,
        imageUrl: branchFallbacks[i % branchFallbacks.length],
    }));
};

export const resolveAboutImage = (url, fallback) => {
    if (hasText(url) && url !== 'string' && !url.includes('<')) {
        if (url.startsWith('/') || url.startsWith('http') || url.startsWith('data:')) return url;
    }
    return fallback || ABOUT_PLACEHOLDER_IMAGES.hero;
};

export const getAboutImageUrl = (url, fallback) => {
    const picked = resolveAboutImage(url, fallback);
    if (
        picked.startsWith('/assets/') ||
        picked.startsWith('http') ||
        picked.startsWith('data:') ||
        picked.startsWith('blob:')
    ) {
        return picked;
    }
    return normalizeImageUrl(picked);
};
